export default __webpack_public_path__ + "static/media/img-collab.6c024fd3.png";